<template>
  <div>
    <vue-headful
    :title="propsdata[0]['translation']['account-title-account-settings']"
    :description="propsdata[0]['translation']['account-description-account-settings']"
/>

<div v-if="loading" class="loader" style="margin: 100px auto;">
  <br><br>
  <div>
    <ul>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
    </ul>
  </div><span>{{propsdata[0]['translation']['account-loading']}}</span>
</div>


    <div v-if="!loading" class="sc-kEYyzF grKTOC">
      <div class="sc-kAdXeD jwoEpG" style="padding: 0px 0px 30px 0px!important">
         <div class="sc-bvTASY jPMoWD">
            <div class="sc-cFlXAS WflZx">
               <div style="position: relative;">

                <div>
                        <div class="card border-light shadow-soft" style="margin-bottom:20px;padding: 10px;border-left: .0625rem solid rgba(243,247,250,.05); border-right: .0625rem solid rgba(243,247,250,.05); border-bottom: .0625rem solid rgba(243,247,250,.05); border-top: 0; border-radius: 0 0 .5rem .5rem;">
                          <div class="card-body p-4 p-lg-3">
                                  <div class="row">
                                      <div class="col-12">
                                          <div class="form-group">
                                              <label class="form-label text-dark">{{propsdata[0]['translation']['account-full-name']}}</label>
                                              <div class="input-group mb-2">
                                                  <div class="input-group-prepend">
                                                      <span class="input-group-text"><i class="fas fa-user-alt"></i></span>
                                                  </div>
                                                  <input v-model="propsdata[0].name" name="name" class="form-control" placeholder="eg. John Doe" type="text">
                                              </div>
                                              <button v-if="!saving" @click="guardarname" style="width: 100%;" class="btn btn-primary animate-up-2"><span class="mr-2"><i class="fas fa-paper-plane"></i></span>{{propsdata[0]['translation']['account-save-name']}}</button>
                                              <button v-if="saving" style="width: 100%;background:#04a677!important;border-color:#04a677!important;" class="btn btn-primary animate-up-2"><span class="mr-2"><i class="fas fa-check"></i></span>{{propsdata[0]['translation']['account-saved-name']}}</button>
                                          </div>
                                      </div>
                                      <div class="col-12">
                                          <div class="form-group">
                                              <label class="form-label text-dark">{{propsdata[0]['translation']['account-email']}}</label>
                                              <div class="input-group mb-2">
                                                  <div class="input-group-prepend">
                                                      <span class="input-group-text"><i class="fas fa-envelope"></i></span>
                                                  </div>
                                                  <input :value="propsdata[0].email" name="name" class="form-control" type="text" disabled>
                                              </div>
                                          </div>
                                          <p>{{propsdata[0]['translation']['account-email-description']}}</p>
                                      </div>
                                      <hr>
                                      <div class="col-12 p-0">
                                         <div class="form-group col-12">
                                            <label class="form-label text-dark">{{propsdata[0]['translation']['account-choose-language']}}</label>
                                            <select v-model='language' class="custom-select mb-2" id="selectlanguages">
                                            <option value='en'>{{propsdata[0]['translation']['account-english']}}</option>
                                            <option value='es'>{{propsdata[0]['translation']['account-spanish']}}</option>
                                            </select>
                                            <button v-if="!savinglanguage" @click="changelanguage" style="width: 100%;" class="btn btn-primary animate-up-2">{{propsdata[0]['translation']['account-button-save-language']}}</button>
                                            <button v-if="savinglanguage" style="width: 100%;" class="btn btn-primary animate-up-2">{{propsdata[0]['translation']['account-button-saving-language']}}</button>
                                         </div>
                                      </div>
                                  </div>
                          </div>
                      </div>

<div v-if="propsdata[0].paid !== 'yes'">
  <div class="card border-light shadow-soft" style="margin-bottom:20px;padding: 10px;border-left: .0625rem solid rgba(243,247,250,.05); border-right: .0625rem solid rgba(243,247,250,.05); border-bottom: .0625rem solid rgba(243,247,250,.05); border-top: 0; border-radius: 0 0 .5rem .5rem;">
    <div class="card-body p-4 p-lg-3">
      <div class="row">
        <div class="col-12 col-md-6 mb-lg-0">
          <h3 class="mb-3">{{propsdata[0]['translation']['account-free']}}</h3>
          <p class="text-muted mb-4">{{propsdata[0]['translation']['account-free-description']}}</p>
        </div>
        <div class="col-12 col-md-6 d-flex align-items-center justify-content-md-end">
          <a :href="'/choose-plan/'+propsdata[0].unique_id" class="btn btn-md btn-pricing-plan animate-up-2" style="color: #ffffff; background-color: #0949b3; border-color: rgb(255, 255, 255);"><svg width="24" height="24" fill="#ffffff" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" class="sc-eNQAEJ bqIowC"><path d="M5 12.5H15V14H5V12.5Z M5 11L4 7L8 8L10 4L12 8L16 7L15 11H5Z"></path></svg>
            {{propsdata[0]['translation']['account-upgrade']}}</a>
        </div>
      </div>
    </div>
  </div>
</div>

                  </div>


             </div>
          </div>
       </div>
    </div>
  </div>
  </div>

</template>

  <script>
  export default {
    props:['propsdata'],
    data() {
      return {
        loading: true,
        saving: false,
        cancelling: false,
        canceled: false,
        cancellation_error: false,
        language: '',
        savinglanguage: false
      };
    },
    methods: {
      guardarname(){
        this.saving = true;
        axios.post('/dashboard/enviar-account.php', {
          name: this.propsdata[0].name
          })
          .then(response => {
            this.invoices = response.data;
            this.saving = false;
        })
          .catch(function (error) {
            console.log(error);
          });
      },
      changelanguage(){
        this.savinglanguage = true;
        axios.post('/dashboard/change-language.php', {
          language: this.language
          })
          .then(response => {
            window.location.href = 'https://termify.io/dashboard/account';
          })
          .catch(function (error) {
            console.log(error);
          });
      },
    },
    mounted() {
      this.$emit('updateprops');
      this.loading = false;
      setTimeout(() => {
        this.language = this.propsdata[0].language;
      }, 1000);
    }
  };
  </script>



// WEBPACK FOOTER //
// src/account.vue